// TODO: vitest component test (pages are covered by Playwright e2e)
import { useState } from 'react'
import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { ArrowLeft } from 'lucide-react'
import { useForgotPassword } from '@/hooks/usePasswordReset'
import { BetaTag } from '@/components/ui/BetaTag'
import { Input } from '@/components/ui/Input'
import { Alert } from '@/components/ui/Alert'
import { Button } from '@/components/ui/Button'
import { Card } from '@/components/ui/Card'

export function ForgotPasswordPage() {
  const { t } = useTranslation('auth')
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const forgotPassword = useForgotPassword()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    await forgotPassword.mutateAsync(email)
    setSubmitted(true)
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-base-200">
      <Card className="w-full max-w-md shadow-xl">
          <div className="text-center mb-6">
            <h1 className="text-2xl font-bold text-primary inline-flex items-center justify-center gap-2">
              FlowRent
              <BetaTag />
            </h1>
            <p className="text-base-content/60">{t('forgot_password.title')}</p>
          </div>

          {submitted ? (
            <div className="text-center space-y-4">
              <Alert variant="success" icon={null}>
                <span>{t('forgot_password.success_message')}</span>
              </Alert>
              <Button
                as={Link}
                to="/login"
                variant="ghost"
                size="sm"
                leftIcon={<ArrowLeft className="w-4 h-4" />}
              >
                {t('forgot_password.back_to_login')}
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <p className="text-sm text-base-content/60">
                {t('forgot_password.subtitle')}
              </p>

              <Input
                label={t('forgot_password.email')}
                type="email"
                placeholder={t('forgot_password.email_placeholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <Button
                type="submit"
                block
                disabled={forgotPassword.isPending}
                loading={forgotPassword.isPending}
              >
                {t('forgot_password.submit')}
              </Button>

              <div className="text-center">
                <Link to="/login" className="link link-hover text-sm gap-1 inline-flex items-center">
                  <ArrowLeft className="w-3 h-3" />
                  {t('forgot_password.back_to_login')}
                </Link>
              </div>
            </form>
          )}
      </Card>
    </div>
  )
}
